import { apiClient } from '@/api/client'
import type { ApiResponse } from '@/types/api'

export interface DataPromotionExportRequest {
  promotionKey: string
  curriculumIds: number[]
  bookIds: number[]
  include: {
    learningConfigurations: boolean
    products: boolean
    pricing: boolean
    contentFeePlans: boolean
    printBooks: boolean
  }
}

export interface DataPromotionExportResponse {
  promotionKey: string
  manifestUri: string
  checksum: string
  contentCount: number
  relationshipCount: number
  productCount: number
  bookCount: number
  quetureContentCount: number
}

export const dataPromotionApi = {
  exportManifest: async (request: DataPromotionExportRequest): Promise<DataPromotionExportResponse> => {
    const { data } = await apiClient.post<ApiResponse<DataPromotionExportResponse>>(
      '/admin/data-promotions/export',
      request,
    )
    if (!data.data) throw new Error('승격 manifest를 생성하지 못했습니다.')
    return data.data
  },
}
